module.exports = __webpack_public_path__ + "static/img/Gacha15.ef4dd1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha15.png
// module id = xOaF
// module chunks = 1